import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from '../../components/TemplateDashboard';
import AlertNotificaciones from '../../components/AlertNotificaciones/AlertNotificaciones';
import TutoriasIndividualesContent from './components/TutoriasIndividualesContent';

const TutoriasIndividuales = () => {

    return (
        <>

            <TemplateDashboard>
                <AlertNotificaciones />
                <TutoriasIndividualesContent />
            </TemplateDashboard>

        </>
    )
};

export default TutoriasIndividuales;